import { FC } from "react"
import { TopBarConfig } from "./TopBarContext"
import { TopBar } from "panels/content/top-bar/TopBar"

interface TopBarControllerProps {
    config: TopBarConfig | undefined
}
const TopBarController: FC<TopBarControllerProps> = ({ config }) => {
    if (config?.Item) {
        return <config.Item />
    }

    return <TopBar />
}

export { TopBarController }
